import { FunctionComponent, useState } from 'react'
import { ChecklistDocument } from '@black-bear-energy/black-bear-energy-common'
import {
  Button,
  IconButton,
  rucksack,
  Tooltip,
} from '@black-bear-energy/rucksack'
import {
  CheckCircleRounded,
  ErrorOutlineRounded,
  UploadRounded,
} from '@mui/icons-material'
import { UploadDocumentModal } from './UploadDocumentModal'
import { ReviewDocumentModal } from './ReviewDocumentModal'

export const DocumentActionShortcut: FunctionComponent<
  DocumentActionShortcutProps
> = ({ document, isLimitedUser }) => {
  const [modalOpen, setModalOpen] = useState(false)

  const isRejected =
    document.review && !document.review.outdated && !document.review.verified

  if (!document.uploaded || isRejected) {
    return (
      <>
        <IconButton onClick={() => setModalOpen(true)}>
          <UploadRounded sx={{ color: rucksack.palette.primary.main }} />
        </IconButton>
        <UploadDocumentModal
          documentId={document.id}
          documentName={document.name}
          open={modalOpen}
          onClose={() => setModalOpen(false)}
          hasExistingUpload={document.uploaded}
        />
      </>
    )
  }

  if (!document.review || document.review.outdated) {
    if (isLimitedUser) {
      // for channel partners/clients, show an icon
      return (
        <Tooltip title="Review Needed">
          <ErrorOutlineRounded sx={{ color: rucksack.palette.warning.main }} />
        </Tooltip>
      )
    }

    // for BBE users/super admins, show a review button
    return (
      <>
        <Button
          onClick={() => setModalOpen(true)}
          sx={{
            border: `1px solid rgba(73, 173, 214, 0.50)`,
            color: rucksack.palette.primary.dark,
            width: '65px',
            height: '30px',
          }}
        >
          Review
        </Button>
        <ReviewDocumentModal
          documentId={document.id}
          documentName={document.name}
          open={modalOpen}
          handleClose={() => setModalOpen(false)}
        />
      </>
    )
  }

  return (
    <Tooltip title="All Documents Reviewed">
      <CheckCircleRounded sx={{ color: rucksack.palette.success.main }} />
    </Tooltip>
  )
}

interface DocumentActionShortcutProps {
  document: ChecklistDocument
  isLimitedUser: boolean
}
